import React from 'react';
import PropTypes from 'prop-types';
import { prop } from 'ramda';

import {
  ConfirmModal,
} from '../../../../ui-kit';

const LeaveChannelModal = ({
  isOpen,
  isPending,
  onClose,
  channel,
  onLeave,
}) => (
  <ConfirmModal
    isOpen={isOpen}
    isPending={isPending}
    actionTitle="Leave"
    onAction={onLeave}
    onClose={onClose}
    title="Leave Channel"
  >

    Are you sure you want to leave
    <b>{prop('name', channel)}</b>

    channel?
  </ConfirmModal>
);

LeaveChannelModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isPending: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onLeave: PropTypes.func.isRequired,
  channel: PropTypes.shape({}).isRequired,
};

export default LeaveChannelModal;
